/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
import React from 'react';
import {Container, Button, Modal, ModalHeader, ModalBody, ModalFooter} from './reactstrap/lib';

class Test extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }

  render() {
    return (
      <Container>
        <Button color="danger" onClick={this.toggle}>{this.props.buttonLabel}</Button>
        <Modal isOpen={this.state.modal} toggle={this.toggle} className='modal-small'>
          <ModalHeader toggle={this.toggle}>Не хватает средств для заказа</ModalHeader>
          <ModalBody>
            <div>
              <div className="mt-4 mb-4">Пополните ваш баланс или обратитесь к менеджерам</div>
              <div className="mb-3">
                <p>+7 (495) 649 62 53</p>
                <p>order@ketex.ru</p>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggle}>Понятно</Button>
          </ModalFooter>
        </Modal>
      </Container>
    );
  }
}


export default Test;



/** WEBPACK FOOTER **
 ** ./src/components/Common/Test.jsx
 **/